import type { IconSvgObject } from './types';

const PlazaIcon: IconSvgObject = [
  ["path", { d: "M2 22L22 21.9873", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 22V10.4783L13 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M7 10.0057L9 9.99561M7 14.003L9 13.9928M7 18.0002L9 17.99", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M4 22V5.82898L13 2V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default PlazaIcon;
